/**
 * 這一頁是不是跑在 Stockable 的 iOS 殼（Capacitor WKWebView）裡。
 *
 * Capacitor 在頁面腳本執行前就注入 `window.Capacitor`，所以第一次 render 就讀得到。
 * 刻意不做全域 `interface Window` 擴充：原生橋的型別由 lib/auth/token-store.ts
 * 那一側宣告，兩處各自擴充同一個屬性會互相衝突；這裡只需要一個方法。
 */
interface CapacitorProbe {
  Capacitor?: { isNativePlatform?: () => boolean };
}

export function isNativeApp(): boolean {
  if (typeof window === 'undefined') return false;
  return (window as unknown as CapacitorProbe).Capacitor?.isNativePlatform?.() === true;
}
